import { MAX_COUNT, type SimState } from './state';

/** Safe cumulative paid time, or null once saturation makes history unknowable. */
export function anchorPaidTicks(state: SimState): number | null {
  if (!Number.isFinite(state.tick) || !Number.isFinite(state.skippedTicks)) return null;
  if (state.skippedTicks >= MAX_COUNT) return null;
  return state.tick - state.skippedTicks;
}
